<template>
  <Modal v-on="$listeners" v-bind="$attrs" :large="true">
    <template v-slot:title>  <i class="fas fa-smile mr-2"></i> Feedback</template>
    <template v-slot:body>
      <div class="form-group p-2">
        <p>The only way to build a kick-ass product is together. We'd love to hear about what you like in using Contexted, and what we could improve.</p>
        <!-- <p>Therefore, we'll reward you with <b>60 days of free use extra</b> if you take the effort to give feedback.</p> -->
        <textarea class="form-control feedback" v-model="feedback" placeholder="What I (dis)like is.."></textarea>
        <div class="custom-control custom-checkbox" v-if="user">
          <input type="checkbox" class="custom-control-input" id="send-feedback-anonymous" v-model="sendFeedbackAnonymous" />
          <label class="custom-control-label mt-2" for="send-feedback-anonymous">Send your feedback anonymously</label>
        </div>
      </div>
      <div v-if="feedbackSent">Thank you for your feedback!</div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary" @click="sendFeedback" :disabled="feedbackSent">
        <template v-if="sendingFeedback">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span>Send feedback</span>
        </template>
        <template v-else>Send feedback</template>
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/Modal'
import { sendFeedback } from '@/utils/services'
import { trackEvent } from '@/utils/analytics'

export default {
  components: {
    Modal
  },
  data() {
    return {
      feedback: '',
      feedbackSent: false,
      sendingFeedback: false,
      sendFeedbackAnonymous: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted() {
    trackEvent('open feedback form', {
      eventCategory: 'feedback',
      eventAction: 'show'
    })
  },
  methods: {
    async sendFeedback() {
      this.sendingFeedback = true
      await sendFeedback({
        user: this.user,
        feedback: this.feedback,
        sendFeedbackAnonymous: this.sendFeedbackAnonymous
      })
      trackEvent('send feedback', {
        eventCategory: 'feedback',
        eventAction: 'send'
      })
      this.sendingFeedback = false
      this.feedbackSent = true
    }
  }
}
</script>
